import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const WarningSvg = (props: IIconProps) => {
  const { width = 16, height = 16, fill = "#853E00" } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.57732 1.99993L14.928 12.9999C14.9865 13.1013 15.0173 13.2162 15.0173 13.3333C15.0173 13.4503 14.9865 13.5652 14.928 13.6666C14.8695
      13.7679 14.7853 13.8521 14.684 13.9106C14.5826 13.9691 14.4677 13.9999 14.3506 13.9999H1.64932C1.53229 13.9999 1.41733 13.9691 1.31599 13.9106C1.21464
      13.8521 1.13049 13.7679 1.07198 13.6666C1.01347 13.5652 0.982665 13.4503 0.982666 13.3333C0.982667 13.2162 1.01347 13.1013 1.07198 12.9999L7.42265
      1.99993C7.48116 1.89859 7.56532 1.81444 7.66666 1.75593C7.76801 1.69743 7.88296 1.66663 7.99998 1.66663C8.117 1.66663 8.23196 1.69743 8.3333
        1.75593C8.43464 1.81444 8.5188 1.89859 8.57732 1.99993ZM2.80398 12.6666H13.196L7.99998 3.6666L2.80398 12.6666ZM7.33332
         10.6666H8.66665V11.9999H7.33332V10.6666ZM7.33332 5.99993H8.66665V9.33326H7.33332V5.99993Z"
        fill={fill}
      />
    </svg>
  );
};
// NOSONAR
const Warning = (props: IIconProps) => <Icon component={() => <WarningSvg {...props} />} {...props} />;

export default Warning;
